export function forwardGutterWheel(
  e: React.WheelEvent,
  scrollEl: HTMLElement | null,
  assetType: string | null | undefined,
) {
  if (assetType !== 'Article') return
  if (e.target !== e.currentTarget) return
  if (scrollEl) scrollEl.scrollTop += e.deltaY
}
